@if (errorText) {
  <div class="error-msg">
    <small class="p-error">{{errorText}}</small>
  </div>
}
